import { HTMLProps } from "react";
import styled from "styled-components";
import { Theme } from "../../../../@types/theme";

interface VStackProps extends HTMLProps<HTMLDivElement> {
  margin?: string;
  height?: string;
}

export const VStack = styled.div<VStackProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${({ height }) => (height ? height : "")};
  justify-content: space-between;
  margin: ${({ margin }) => (margin ? margin : "")};
`;
export const GridItem = styled.div`
  width: 100%;
  height: 100%;
  max-height: 128px;
  max-width: 133px;

  min-height: 128px;
  min-width: 133px;
  display: flex;
  position: relative;
  border-radius: 1rem;
  align-items: center;
  justify-content: center;

  .close-icon {
    position: absolute;
    right: 5px;
    top: 5px;
    width: 12px;
    height: 12px;
    cursor: pointer !important;
    z-index: 300;
  }
`;

export const HStack = styled.div`
  display: flex;
  flex-direction: column;

  .wrapper-upload-images {
    background-color: rgba(255, 255, 255, 0.6) !important;
  }

  @media (max-width: 1600px) {
    .grid-upload-images {
      grid-template-columns: repeat(4, 1fr) !important;
    }
  }

  @media (max-width: 1366px) {
    .grid-upload-images {
      grid-template-columns: repeat(3, 1fr) !important;
    }
  }
`;

export const Heading = styled.div`
  font-size: 1.8rem;
  margin: 1.8rem 0 1.8rem 1.6rem;
  color: ${({ theme }: Theme) => theme.colors.black};

  @media (max-width: 1600px) {
    font-size: 1.6rem;
    margin: 1.8rem 0 1.5rem 1.6rem;
  }

  @media (max-width: 1366px) {
    font-size: 1.5rem;
    margin: 1.8rem 0 1.3rem 1.6rem;
  }
`;

export const Center = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Box = styled.div`
  width: 100;
  height: 100%;
  display: flex;
`;
